import { WithdrawalAmount } from '../../../../investment/components/transfer/WithdrawalAmount';

export default function WithdrawalAmountScreen() {
    return <WithdrawalAmount />;
}
